import { StyledMainSection } from "@/styles/global";
import { GatsbyImage } from "gatsby-plugin-image";
import styled from "styled-components";

type ImageProps = {
  $layout: "horizontal" | "vertical" | "mobileVertical";
};

const Section = styled(StyledMainSection)``;

const ImageWrapper = styled.div<ImageProps>`
  position: relative;
  border-radius: 21px;
  overflow: hidden;
  margin: 0 auto;

  max-width: ${({ $layout }) =>
    $layout === "mobileVertical" ? "350px" : "100%"};

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    max-width: ${({ $layout }) =>
      $layout === "horizontal" ? "100%" : "500px"};
  }
`;

const Image = styled(GatsbyImage)`
  width: 100%;
  height: 100%;

  img {
    object-fit: cover;
    object-position: center;
    border-radius: 21px;
  }
`;

const S = {
  Section,
  ImageWrapper,
  Image,
};

export default S;
